__turbopack_context__.v({
  "content": "NQY9AG_content",
  "hero": "NQY9AG_hero",
  "heroText": "NQY9AG_heroText",
  "heroTitle": "NQY9AG_heroTitle",
  "inlineSection": "NQY9AG_inlineSection",
  "learnMoreButton": "NQY9AG_learnMoreButton",
  "mantine-Accordion-content": "NQY9AG_mantine-Accordion-content",
});
